import compact from 'lodash/compact';

import type { Category, NavigationGutterItem } from '~/@types/redux';
import { RULE_RESULT_STATUS_ID } from '~/common/constants';

// Single source of truth for which icon a top-nav tab shows, mirroring
// CategoriesNav/Notification exactly so navigation logic never drifts from
// what the user actually sees rendered.

const isGutterItemVerified = (gutterItem: NavigationGutterItem): boolean => {
  if (gutterItem?.gutterItemChildren?.length === 0) {
    return (
      gutterItem?.ruleResultId === 0 ||
      (gutterItem?.isUnderwriterVerified ?? false)
    );
  }

  return gutterItem?.gutterItemChildren?.every(isGutterItemVerified) ?? false;
};

export const isTopNavCategoryVerified = (category?: Category): boolean => {
  if (category?.navigationGutterItems?.length === 0) return false;

  return category?.navigationGutterItems?.every(isGutterItemVerified) ?? false;
};

export const getNumberOfActiveAlertsForCategory = (
  category?: Category,
): number =>
  compact(
    category?.navigationGutterItems?.flatMap((navigationGutterItem) => {
      if (navigationGutterItem?.gutterItemChildren?.length > 0) {
        return navigationGutterItem.gutterItemChildren.filter(
          (childItem) =>
            childItem?.ruleResultStatusId === RULE_RESULT_STATUS_ID.FIRED,
        );
      }

      if (
        navigationGutterItem?.ruleResultStatusId === RULE_RESULT_STATUS_ID.FIRED
      ) {
        return navigationGutterItem;
      }

      return null;
    }),
  )?.length ?? 0;
